import gql from 'graphql-tag';

export const UPLOAD_BLOCK_TEMPLATE = gql`
  mutation UploadBlockTemplate($data: [BlockTemplateInput!]!) {
    uploadBlockTemplate(data: $data)
  }
`;

export const CREATE_SALESFORCE_CASE_FROM_CARE_CONNECT = gql`
  mutation createSalesforceCaseFromCareConnect(
    $data: [CreateSfCaseFromCareConnectInput!]!
  ) {
    createSalesforceCaseFromCareConnect(data: $data)
  }
`;
